<div class="my-account-settings mc-nav-menu" walkThroughStep="settings">
  <button
    [class.agency-header]="isAgency"
    matTooltip="Your profile and settings"
    matTooltipClass="my-account-tooltip"
    aria-label="Your profile and settings"
    class="my-account-settings__btn"
    (click)="showSettingsMenu()"
    (clickOutside)="closeSettingsMenu()"
    data-testid="settings.button"
  >
    {{ userData.shortName }}
  </button>
  <mc-tooltip-panel-wrapper [class.hidden]="!showTooltip" (focusout)="blurTooltip($event)">
    <mc-tooltip-panel class="tooltip-panel" [position]="'bottom-right'" [forceOpen]="showTooltip">
      <div class="tooltip-body">
        <div class="user-data">
          <p class="user-data__name">{{ userData.fullName }}</p>
          <p class="user-data__email">{{ userData.email }}</p>
          <span></span>
        </div>
        <div class="settings">
          <mc-nav-item
            [isActive]="currentRoute === navigationUrls.General"
            [label]="'My Account'"
            [link]="navigationUrls.General"
            (navigate)="closeSettingsMenu()"
          >
          </mc-nav-item>
          <ng-container *onlyRegTrackModeGuard="RegTrackMode.Subscriptions">
            <mc-nav-item
              *permissionGuard="UserPermissions.manageBilling.subscriptionPage"
              [isActive]="currentRoute === navigationUrls.Subscriptions"
              [label]="'Subscriptions'"
              [link]="navigationUrls.Subscriptions"
              (navigate)="closeSettingsMenu()"
            >
            </mc-nav-item
          ></ng-container>
          <ng-container *onlyRegTrackModeGuard="RegTrackMode.Billing">
            <mc-nav-item
              *permissionGuard="UserPermissions.manageBilling.billingInvoicesPage"
              [isActive]="currentRoute === navigationUrls.BillingInvoice"
              [label]="'MENU.BILLING-INVOICES' | translate"
              [link]="navigationUrls.BillingInvoice"
              (navigate)="closeSettingsMenu()"
            >
            </mc-nav-item>
          </ng-container>
          <!--          [NEW-GROUP] - disabled for ticket DASH-1168-->
          <!-- TODO: Need add a permission guard-->
          <!--          @if (groupsFeatureFlag) {-->
          <!--            <mc-nav-item-->
          <!--              [isActive]="currentRoute === navigationUrls.AccountManagement"-->
          <!--              [label]="'MENU.MANAGE-ACCOUNTS' | translate"-->
          <!--              [link]="navigationUrls.AccountManagement"-->
          <!--              (navigate)="closeSettingsMenu(navigationUrls.AccountManagement)"-->
          <!--            >-->
          <!--            </mc-nav-item>-->
          <!--          }-->
        </div>
        <div class="log-out-nav-item">
          <mc-nav-item
            [label]="'MENU.SIGN-OUT' | translate"
            (navigate)="logout()"
            data-testid="settings.options.logout"
          >
          </mc-nav-item>
        </div>
        <div class="log-out-nav-item info-nav-items">
          <a href="https://userway.org/privacy" target="_blank" rel="noopener noreferrer" class="info-link"
            >Privacy Policy</a
          >
          <span>&nbsp;•&nbsp;</span>
          <a href="https://userway.org/terms" target="_blank" rel="noopener noreferrer" class="info-link"
            >Terms of Service</a
          >
        </div>
      </div>
    </mc-tooltip-panel>
  </mc-tooltip-panel-wrapper>
</div>
